
import { buildFixedSrcSet, buildSrc } from '@Utils/images';

export default {
  name: 'EditoFooter',
  props: {
    /**
     * Bottom content
     */
    bottomContent: {
      type: String,
      default: undefined,
    },
    /**
     * image
     */
    img: {
      type: [Object, String],
      default: undefined,
    },
    /**
     * Title text
     */
    title: {
      type: String,
      default: undefined,
    },
    /**
     * Top content
     */
    topContent: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    imgFooter() {
      if (!this.img) {
        return undefined;
      }

      return {
        alt: '',
        height: '200',
        loading: 'lazy',
        role: 'presentation',
        src: buildSrc({
          img: this.img,
          width: 200,
        }),
        srcset: buildFixedSrcSet({
          img: this.img,
          width: 200,
        }),
        width: '200',
      };
    },
  },
};
